import React from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import "./ButtonTabs.css";
import { makeStyles } from "@mui/styles";

const ButtonTabs = (props) => {
  const { value, handleChange, tabs, disabled } = props;

  const useStyles = makeStyles({
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: "#DB233A",
      },
      "& .MuiTab-root.Mui-selected": {
        color: "#DB233A",
      },
    },
  });
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons
      className={classes.tabs}
      textColor="secondary"
      indicatorColor="secondary"
      aria-label="secondary tabs example"
    >
      {tabs.map((tab, index) => {
        return <Tab label={tab.label} style={{ fontWeight: "600" }} key={index} {...tab.value} disabled={tab.disabled} />;
      })}
    </Tabs>
  );
};

export default ButtonTabs;
